import { DesktopOverlay, MobileDisclosure } from './components';
import { useLocalStorage, useMedia, useTracking } from '../../hooks';
import api from '../../api';
import React, { useEffect, useState } from 'react';
import { useFormStore } from '@ariakit/react';
import PropTypes from 'prop-types';

const BusinessJourneyOverlay = ({ storageName }) => {
  const isMobile = useMedia('(max-width: 767px)');
  const [startInteraction, setStartInteraction] = useState(null);
  const tracking = useTracking();

  const [storage, setStorage] = useLocalStorage(storageName, {
    answers: [],
    selectedProducts: [],
    pageLink: '',
    emailSent: false,
  });

  const handleClose = () => {
    setStorage({
      answers: [],
      selectedProducts: [],
      pageLink: '',
      emailSent: false,
    });
  };

  const [values, setValues] = useState({ email: '' });
  const form = useFormStore({ values, setValues });

  form.useValidate(() => {
    if (!values.email) {
      form.setError('email', 'Bitte kontrollieren Sie Ihre Eingabe.');
    }
  });

  form.useSubmit(async () => {
    const submitTime = new Date();
    const difference = (submitTime - startInteraction) / 1000;

    // Honeypot logic to prevent bots from submitting too quickly
    if (difference > 0.3) {
      try {
        await api.post('/contactform/productrecommender', {
          linkList: storage?.selectedProducts,
          email: values?.email,
        });
        tracking({
          event: 'B2BProduktWegweiser_send',
          answers: storage?.answers.map(answ => answ.title.trim()),
          products: storage?.selectedProducts.map(product => product?.link),
          step: 'success',
        });
        setStorage(currentStorage => ({
          ...currentStorage,
          emailSent: true,
        }));
      } catch {
        alert('Something went wrong, please try again');
      }
    }
  });

  useEffect(() => {
    const isFormTouched = Object.keys(values).some(name =>
      form.getFieldTouched(name),
    );

    if (isFormTouched && !startInteraction) {
      setStartInteraction(new Date());
    }
  }, [values]);

  if (!storage?.selectedProducts?.length) {
    return null;
  }

  const OverlayComponent = isMobile ? MobileDisclosure : DesktopOverlay;

  return (
    <OverlayComponent
      formSuccess={storage.emailSent}
      linkList={storage.selectedProducts}
      pageLink={storage.pageLink || ''}
      setOverlayVisibility={handleClose}
      store={form}
    />
  );
};

BusinessJourneyOverlay.propTypes = {
  storageName: PropTypes.string,
};

export { BusinessJourneyOverlay };
